import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Table, Card, Button, Form, Pagination, InputGroup, Badge, Accordion } from 'react-bootstrap';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { FaSearch, FaPlus, FaLock, FaQuestionCircle, FaAngleDown } from 'react-icons/fa';
import { formatDate } from '../utils/helpers';

const QnaList = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  
  // 상태 관리
  const [qnas, setQnas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(parseInt(searchParams.get('page') || '1'));
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState(searchParams.get('search') || '');
  const [category, setCategory] = useState(searchParams.get('category') || '전체');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  // 페이지당 항목 수
  const itemsPerPage = 10;
  
  // 카테고리 목록
  const categories = ['전체', '서비스 이용', '공양 문의', '사찰 문의', '계정 관련', '기타'];
  
  // 예시 Q&A 데이터 (실제로는 API에서 가져옴)
  const dummyQnas = [
    { id: 1, title: '공양 신청 후 취소는 어떻게 하나요?', content: '공양 신청을 했는데 취소하고 싶습니다. 어떻게 해야 하나요?', category: '공양 문의', isAnswered: true, answer: '공양 신청 취소는 마이페이지 > 신청 내역에서 가능합니다. 단, 배송 준비 중 상태부터는 취소가 제한될 수 있습니다.', createdAt: '2023-12-24T09:10:00', viewCount: 89, isPrivate: false, author: '홍길동' },
    { id: 2, title: '사찰 방문 예약은 어떻게 하나요?', content: '직접 사찰에 방문해서 공양을 올리고 싶은데 예약이 필요한가요?', category: '사찰 문의', isAnswered: true, answer: '사찰 방문 예약은 각 사찰 페이지에서 가능합니다. 사찰별로 방문 공양 가능 시간이 다르니 미리 확인하시는 것이 좋습니다.', createdAt: '2023-12-22T16:40:00', viewCount: 112, isPrivate: false, author: '이몽룡' },
    { id: 3, title: '회원 정보 변경은 어디서 하나요?', content: '이메일 주소를 변경하고 싶습니다.', category: '계정 관련', isAnswered: true, answer: '회원 정보 변경은 우측 상단 프로필 아이콘 > 마이페이지 > 회원정보 관리에서 가능합니다.', createdAt: '2023-12-20T11:30:00', viewCount: 76, isPrivate: false, author: '김삿갓' },
    { id: 4, title: '비밀 문의드립니다', content: '개인적인 공양 문의가 있습니다.', category: '공양 문의', isAnswered: true, answer: '답변 드렸습니다. 추가 문의 있으시면 언제든 남겨주세요.', createdAt: '2023-12-18T14:20:00', viewCount: 1, isPrivate: true, author: '홍길순' },
    { id: 5, title: '공양 가능한 품목은 어떤 것이 있나요?', content: '사찰에 공양할 수 있는 품목 리스트가 있을까요?', category: '공양 문의', isAnswered: true, answer: '기본적으로 음식, 생필품, 연등, 불화, 법보시 등 다양한 공양이 가능합니다. 자세한 내용은 각 사찰 페이지에서 확인하실 수 있습니다.', createdAt: '2023-12-15T09:45:00', viewCount: 134, isPrivate: false, author: '청년불자' },
    { id: 6, title: '앱은 언제 출시되나요?', content: '모바일 앱 출시 계획이 있나요?', category: '서비스 이용', isAnswered: true, answer: '현재 모바일 앱을 개발 중이며, 내년 상반기 중 출시 예정입니다. 출시 전까지는 모바일 웹으로 서비스를 이용해주시기 바랍니다.', createdAt: '2023-12-10T17:30:00', viewCount: 97, isPrivate: false, author: '앱기다림' },
    { id: 7, title: '결제 방법 추가 요청', content: '카카오페이 외에 다른 간편결제도 추가되면 좋겠습니다.', category: '기타', isAnswered: false, answer: null, createdAt: '2023-12-05T13:15:00', viewCount: 68, isPrivate: false, author: '간편결제팬' },
    { id: 8, title: '특별 공양에 대해 문의드립니다', content: '특별 공양은 어떤 절차로 진행되나요?', category: '공양 문의', isAnswered: false, answer: null, createdAt: '2023-12-01T10:20:00', viewCount: 91, isPrivate: false, author: '신도1234' },
    { id: 9, title: '회원 탈퇴는 어떻게 하나요?', content: '회원 탈퇴 방법을 알려주세요.', category: '계정 관련', isAnswered: true, answer: '마이페이지 > 회원정보 관리 > 하단의 회원 탈퇴 버튼을 통해 가능합니다. 탈퇴 시 모든 개인정보는 삭제되며 복구가 불가능합니다.', createdAt: '2023-11-28T15:50:00', viewCount: 102, isPrivate: false, author: '탈퇴예정' },
    { id: 10, title: '비밀 문의글은 어떻게 작성하나요?', content: '다른 사람들이 볼 수 없는 문의를 남기고 싶습니다.', category: '서비스 이용', isAnswered: true, answer: 'Q&A 작성 시 "비밀글로 작성" 옵션을 체크하시면 작성자와 관리자만 볼 수 있는 비밀글로 등록됩니다.', createdAt: '2023-11-25T11:40:00', viewCount: 88, isPrivate: false, author: '비밀문의자' }
  ];
  
  // 인증 상태 확인
  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('accessToken');
      setIsAuthenticated(!!token);
    };
    
    checkAuth();
  }, []);
  
  // 데이터 페이징 및 필터링 로직
  useEffect(() => {
    setLoading(true);
    
    try {
      // API 호출 대신 더미 데이터 활용
      let filteredQnas = [...dummyQnas];
      
      // 카테고리 필터링
      if (category && category !== '전체') {
        filteredQnas = filteredQnas.filter(qna => qna.category === category);
      }
      
      // 검색어 필터링
      if (searchTerm) {
        filteredQnas = filteredQnas.filter(qna => 
          qna.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
          qna.content.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }
      
      // 페이징 적용
      const totalItems = filteredQnas.length;
      setTotalPages(Math.ceil(totalItems / itemsPerPage));
      
      // 현재 페이지에 해당하는 항목만 추출
      const startIndex = (currentPage - 1) * itemsPerPage;
      const paginatedQnas = filteredQnas.slice(startIndex, startIndex + itemsPerPage);
      
      setQnas(paginatedQnas);
      setError(null);
    } catch (err) {
      setError('Q&A 목록을 불러오는 중 오류가 발생했습니다.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [currentPage, searchTerm, category]);
  
  // 페이지 변경 핸들러
  const handlePageChange = (page) => {
    setCurrentPage(page);
    const params = new URLSearchParams(searchParams);
    params.set('page', page);
    setSearchParams(params);
  };
  
  // 검색 핸들러
  const handleSearch = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (searchTerm) params.set('search', searchTerm);
    if (category !== '전체') params.set('category', category);
    params.set('page', '1');
    setSearchParams(params);
    setCurrentPage(1);
  };
  
  // 카테고리 변경 핸들러
  const handleCategoryChange = (selectedCategory) => {
    setCategory(selectedCategory);
    const params = new URLSearchParams(searchParams);
    if (selectedCategory !== '전체') {
      params.set('category', selectedCategory);
    } else {
      params.delete('category');
    }
    params.set('page', '1');
    setSearchParams(params);
    setCurrentPage(1);
  };
  
  // 질문 작성 페이지로 이동
  const handleWriteQna = () => {
    if (isAuthenticated) {
      navigate('/qna/write');
    } else {
      navigate('/login', { state: { from: '/qna/write' } });
    }
  };
  
  // Q&A 상세 페이지로 이동
  const handleQnaClick = (qnaId) => {
    navigate(`/qna/${qnaId}`);
  };
  
  return (
    <div className="qna-list py-5">
      <Container>
        {/* 헤더 섹션 */}
        <section className="mb-5">
          <div className="text-center mb-5">
            <h1 className="display-5 fw-bold mb-2" style={{ color: 'var(--main-color)' }}>
              Q&A
            </h1>
            <div className="d-flex justify-content-center">
              <div className="col-lg-6">
                <p className="lead text-muted">
                  비나이다 서비스 이용 및 공양에 관련된 질문과 답변을 확인하세요.
                </p>
              </div>
            </div>
          </div>
          
          {/* 검색 및 필터링 섹션 */}
          <div className="mb-4">
            <Form onSubmit={handleSearch}>
              <Row className="justify-content-center">
                <Col md={8} lg={6}>
                  <Card className="border-0 shadow-sm rounded-4 mb-4">
                    <Card.Body className="p-4">
                      <div className="mb-3">
                        <div className="d-flex flex-wrap gap-2 justify-content-center">
                          {categories.map((cat) => (
                            <Badge
                              key={cat}
                              bg={cat === category ? 'primary' : 'light'}
                              text={cat === category ? 'white' : 'dark'}
                              style={{
                                cursor: 'pointer',
                                padding: '10px 15px',
                                fontSize: '0.85rem',
                                backgroundColor: cat === category ? 'var(--main-color)' : undefined,
                                borderRadius: '100px',
                                boxShadow: cat === category ? '0 3px 8px rgba(0,149,144,0.25)' : '0 2px 4px rgba(0,0,0,0.04)',
                                transition: 'all 0.2s ease',
                                fontWeight: cat === category ? '500' : 'normal',
                              }}
                              onClick={() => handleCategoryChange(cat)}
                            >
                              {cat}
                            </Badge>
                          ))}
                        </div>
                      </div>
                      
                      <InputGroup className="shadow-sm rounded-pill overflow-hidden">
                        <Form.Control
                          type="text"
                          placeholder="질문 검색하기"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          className="border-0 py-2"
                          style={{ borderRadius: '100px 0 0 100px' }}
                        />
                        <Button 
                          variant="primary" 
                          type="submit"
                          style={{ 
                            backgroundColor: 'var(--main-color)', 
                            borderColor: 'var(--main-color)',
                            borderRadius: '0 100px 100px 0'
                          }}
                        >
                          <FaSearch />
                        </Button>
                      </InputGroup>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Form>
            
            <div className="d-flex justify-content-end mb-3">
              <Button 
                variant="primary" 
                onClick={handleWriteQna}
                className="rounded-pill px-4"
                style={{ 
                  backgroundColor: 'var(--main-color)', 
                  borderColor: 'var(--main-color)',
                  boxShadow: '0 4px 10px rgba(0,149,144,0.2)'
                }}
              >
                <FaPlus className="me-2" /> 질문 작성하기
              </Button>
            </div>
          </div>
        </section>
        
        {/* Q&A 목록 */}
        <section>
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border" style={{ color: 'var(--main-color)' }} role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-3 text-muted">Q&A를 불러오는 중입니다...</p>
            </div>
          ) : error ? (
            <div className="alert alert-danger">{error}</div>
          ) : qnas.length === 0 ? (
            <div className="text-center py-5">
              <p className="text-muted">검색 결과가 없습니다.</p>
            </div>
          ) : (
            <>
              <Accordion className="qna-accordion mb-4">
                {qnas.map((qna) => (
                  <Accordion.Item key={qna.id} eventKey={qna.id.toString()} className="border-0 mb-3 shadow-sm rounded-4 overflow-hidden">
                    <Accordion.Header>
                      <div className="d-flex align-items-center w-100 py-1">
                        <Badge 
                          bg={qna.isAnswered ? 'success' : 'secondary'} 
                          className="me-3 px-2 py-1"
                        >
                          {qna.isAnswered ? '답변완료' : '답변대기'}
                        </Badge>
                        <div className="flex-grow-1">
                          <div className="d-flex align-items-center">
                            {qna.isPrivate && (
                              <FaLock className="me-2 text-muted" size={14} />
                            )}
                            <span className="fw-medium">{qna.title}</span>
                          </div>
                          <div className="d-flex flex-wrap mt-1 small text-muted">
                            <span className="me-3">{qna.category}</span>
                            <span className="me-3">{qna.author}</span>
                            <span>{formatDate(qna.createdAt)}</span>
                          </div>
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body className="px-4 pt-3 pb-4">
                      <div className="qna-content mb-4 bg-light p-3 rounded">
                        <div className="d-flex">
                          <div className="me-3">
                            <FaQuestionCircle style={{ color: 'var(--main-color)' }} size={20} />
                          </div>
                          <div>
                            <p className="mb-0">{qna.content}</p>
                          </div>
                        </div>
                      </div>
                      
                      {qna.isAnswered && (
                        <div className="qna-answer bg-white border p-3 rounded">
                          <div className="d-flex">
                            <div className="me-3">
                              <FaAngleDown style={{ color: '#6c757d' }} size={20} />
                            </div>
                            <div>
                              <p className="mb-0">{qna.answer}</p>
                            </div>
                          </div>
                        </div>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
              
              {/* 페이지네이션 */}
              {totalPages > 1 && (
                <div className="d-flex justify-content-center mt-4">
                  <Pagination className="pagination-custom">
                    <Pagination.First 
                      onClick={() => handlePageChange(1)} 
                      disabled={currentPage === 1}
                    />
                    <Pagination.Prev 
                      onClick={() => handlePageChange(currentPage - 1)} 
                      disabled={currentPage === 1}
                    />
                    
                    {Array.from({ length: Math.min(5, totalPages) }).map((_, index) => {
                      let pageNum;
                      if (totalPages <= 5) {
                        pageNum = index + 1;
                      } else if (currentPage <= 3) {
                        pageNum = index + 1;
                      } else if (currentPage >= totalPages - 2) {
                        pageNum = totalPages - 4 + index;
                      } else {
                        pageNum = currentPage - 2 + index;
                      }
                      
                      return (
                        <Pagination.Item
                          key={pageNum}
                          active={pageNum === currentPage}
                          onClick={() => handlePageChange(pageNum)}
                          style={pageNum === currentPage ? {
                            backgroundColor: 'var(--main-color)',
                            borderColor: 'var(--main-color)',
                            boxShadow: '0 2px 5px rgba(0,149,144,0.3)'
                          } : {}}
                        >
                          {pageNum}
                        </Pagination.Item>
                      );
                    })}
                    
                    <Pagination.Next 
                      onClick={() => handlePageChange(currentPage + 1)} 
                      disabled={currentPage === totalPages}
                    />
                    <Pagination.Last 
                      onClick={() => handlePageChange(totalPages)} 
                      disabled={currentPage === totalPages}
                    />
                  </Pagination>
                </div>
              )}
            </>
          )}
        </section>
      </Container>
      
      <style jsx="true">{`
        .pagination-custom .page-link {
          border-radius: 50% !important;
          margin: 0 3px;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #555;
        }
        
        .pagination-custom .page-item:first-child .page-link,
        .pagination-custom .page-item:last-child .page-link {
          border-radius: 50% !important;
        }
        
        .qna-accordion .accordion-button {
          background-color: white;
          box-shadow: none;
        }
        
        .qna-accordion .accordion-button:not(.collapsed) {
          color: var(--main-color);
          background-color: rgba(0, 149, 144, 0.05);
        }
        
        .qna-accordion .accordion-button:focus {
          box-shadow: none;
          border-color: rgba(0, 149, 144, 0.25);
        }
      `}</style>
    </div>
  );
};

export default QnaList;